export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 py-6 px-4 sm:py-8 sm:px-6">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm">
        <div className="text-gray-700 text-center sm:text-left">
          © <span className="font-semibold">EYESGh</span> 2026 All rights reserved.
        </div>

        {/* Center - Links */}
        <div className="flex items-center gap-4 sm:gap-6">
          <a 
            href="/safeguarding-policy.pdf" 
            className="text-gray-600 hover:text-gray-900 transition-colors"
          >
            Safeguarding Policy
          </a>
          <a 
            href="/privacy-policy.pdf" 
            className="text-gray-600 hover:text-gray-900 transition-colors"
          >
            Privacy Policy
          </a>
        </div>

        <div className="text-gray-500 text-center sm:text-right">
          Powered by{" "}
          <a 
            href="https://techloftt.com" 
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-700 hover:text-gray-900 transition-colors"
          >
            techloft.com
          </a>
        </div>
      </div>
    </footer>
  );
}